

export interface TeacherAvailabilityTemplate {
  id: string;
  teacher_code: string;
  day_of_week: number; // 0=Sunday, 1=Monday, ..., 6=Saturday
  start_time: string;
  end_time: string;
  slot_order: number;
  created_at: string;
  updated_at: string;
}

export interface TeacherAvailabilityException {
  id: string;
  teacher_code: string;
  exception_date: string;
  start_time: string | null;
  end_time: string | null;
  exception_type: 'NO_WORK' | 'PARTIAL_UNAVAILABLE';
  reason: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface WeeklySchedule {
  [key: number]: TeacherAvailabilityTemplate[]; // Array of slots for each day (0=Sun..6=Sat)
}

export const DAY_NAMES = {
  0: 'อาทิตย์',
  1: 'จันทร์',
  2: 'อังคาร',
  3: 'พุธ',
  4: 'พฤหัสบดี',
  5: 'ศุกร์',
  6: 'เสาร์'
};

export const TIME_SLOTS = [
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30',
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
  '21:00', '21:30', '22:00', '22:30'
];

